// Missing metadata remains selectable; this is screening, not a playback guarantee.
function browserCapabilities(video) {
    const supports = type => !!video.canPlayType(type);
    return {
        mkv: supports('video/x-matroska'),
        hevc: supports('video/mp4; codecs="hvc1.1.6.L93.B0"') || supports('video/mp4; codecs="hev1.1.6.L93.B0"'),
        av1: supports('video/mp4; codecs="av01.0.08M.08"'),
        h264: supports('video/mp4; codecs="avc1.42E01E"'),
        ac3: supports('audio/mp4; codecs="ac-3"'),
        eac3: supports('audio/mp4; codecs="ec-3"'),
    };
}
function browserFriendly(stream, caps) {
    const text = `${stream.name || ''} ${stream.description || ''} ${stream.behaviorHints?.filename || ''}`;
    let pathname = '';
    try { pathname = new URL(stream.url).pathname; } catch (_) { /* no direct URL */ }
    const filename = `${stream.behaviorHints?.filename || ''} ${pathname} ${text.split('\n')[0]}`;
    if (/\.mkv(?:\b|$)/i.test(filename) && !caps.mkv) return false;
    if (/\b(?:hevc|h[ ._-]?265|x265)\b/i.test(text) && !caps.hevc) return false;
    if (/\bav1\b/i.test(text) && !caps.av1) return false;
    if (/\b(?:h[ ._-]?264|x264|avc)\b/i.test(text) && !caps.h264) return false;
    const enhancedAudio = /\b(?:e[ ._-]?ac[ ._-]?3|ddp(?:\d|\b)|dolby digital plus)\b/i.test(text);
    if (enhancedAudio && !caps.eac3) return false;
    if (!enhancedAudio && /\b(?:ac[ ._-]?3|dolby digital)\b/i.test(text) && !caps.ac3) return false;
    if (/\b(?:dts(?:[ ._-]?hd)?|truehd)\b/i.test(text)) return false;
    if (stream.infoHash && !stream.url) return false;
    return true;
}
module.exports = { browserCapabilities, browserFriendly };
